/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseSectionPanelAldrinFragment, SectionPanelAldrinFragment, FullSectionPanelAldrinFragment} from '@amblique/contentful/app/contentful/fragments/section-panel-aldrin';

/**
 * Get a single SectionPanelAldrin by ID (base - scalars only)
 */
export const getBaseSectionPanelAldrinById = gql`
  ${BaseSectionPanelAldrinFragment}

  query GetBaseSectionPanelAldrinById($id: String!, $locale: String!, $preview: Boolean) {
    sectionPanelAldrin(id: $id, locale: $locale, preview: $preview) {
      ...BaseSectionPanelAldrinFragment
    }
  }
`;

/**
 * Get a single SectionPanelAldrin by ID (standard - 1 level deep)
 */
export const getSectionPanelAldrinById = gql`
  ${SectionPanelAldrinFragment}

  query GetSectionPanelAldrinById($id: String!, $locale: String!, $preview: Boolean) {
    sectionPanelAldrin(id: $id, locale: $locale, preview: $preview) {
      ...SectionPanelAldrinFragment
    }
  }
`;

/**
 * Get a single SectionPanelAldrin by ID (full - 2 levels deep)
 */
export const getFullSectionPanelAldrinById = gql`
  ${FullSectionPanelAldrinFragment}

  query GetFullSectionPanelAldrinById($id: String!, $locale: String!, $preview: Boolean) {
    sectionPanelAldrin(id: $id, locale: $locale, preview: $preview) {
      ...FullSectionPanelAldrinFragment
    }
  }
`;

/**
 * Get all SectionPanelAldrin entries with pagination (base - scalars only)
 */
export const getBaseSectionPanelAldrins = gql`
  ${BaseSectionPanelAldrinFragment}

  query GetBaseSectionPanelAldrins(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SectionPanelAldrinOrder]
    $where: SectionPanelAldrinFilter
    $preview: Boolean
  ) {
    sectionPanelAldrinCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseSectionPanelAldrinFragment
      }
    }
  }
`;

/**
 * Get all SectionPanelAldrin entries with pagination (standard - 1 level deep)
 */
export const getSectionPanelAldrins = gql`
  ${SectionPanelAldrinFragment}

  query GetSectionPanelAldrins(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SectionPanelAldrinOrder]
    $where: SectionPanelAldrinFilter
    $preview: Boolean
  ) {
    sectionPanelAldrinCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...SectionPanelAldrinFragment
      }
    }
  }
`;

/**
 * Get all SectionPanelAldrin entries with pagination (full - 2 levels deep)
 */
export const getFullSectionPanelAldrins = gql`
  ${FullSectionPanelAldrinFragment}

  query GetFullSectionPanelAldrins(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [SectionPanelAldrinOrder]
    $where: SectionPanelAldrinFilter
    $preview: Boolean
  ) {
    sectionPanelAldrinCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullSectionPanelAldrinFragment
      }
    }
  }
`;
